// extracted by mini-css-extract-plugin
export default {"container":"PageLayout_container__1W+w5","contentLeft":"PageLayout_contentLeft__MgDEU","contentRight":"PageLayout_contentRight__iK4Qr"};